import React from 'react';

const Loading = () => {
  return (
    <div className="loading">
      <div className="spinner" />
    </div>
  );
};

export default Loading;
